module.exports = __webpack_public_path__ + "static/media/menu_dailyLog.2bcc2487.svg";